module.exports = __webpack_public_path__ + "static/media/ico_dashboard_o.f9509c05.svg";